<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header">
        <h3>Scope of Appeal</h3>
    </div>
    <div class="panel-flat-body position-relative" [formGroup]="form()">
        <div class="referral-field-grid">
            <label class="referral-field-label">State</label>
            <span>{{ referral()?.siteStateAbbr }}</span>

            <label class="referral-field-label" for="siteAssessorName">Jurisdiction</label>
            <referral-input-with-revert
                formControlName="siteAssessorName"
                [systemValue]="systemReferral()?.siteAssessorName"
                [originalValue]="originalReferral()?.siteAssessorName"
                [maxlength]="100"
            />

            <label class="referral-field-label" for="taxYear">Tax Year</label>
            <span>{{ referral()?.taxYear }}</span>

            <label class="referral-field-label" for="priorAppealLevel">
                Last Appeal Level
                @if (editMode()) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="priorAppealLevel"
                [systemValue]="systemReferral()?.priorAppealLevel"
                [originalValue]="originalReferral()?.priorAppealLevel"
                [maxlength]="100"
            />

            <label class="referral-field-label" for="priorAppealDecisionDate">
                Date of Appeal Decision
                @if (editMode()) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="priorAppealDecisionDate"
                [systemValue]="systemReferral()?.priorAppealDecisionDate"
                [originalValue]="originalReferral()?.priorAppealDecisionDate"
                [isDate]="true"
            />

            <label class="referral-field-label" for="appealDeadlineDate">Appeal Filing Deadline</label>
            <referral-input-with-revert
                formControlName="appealDeadlineDate"
                [systemValue]="systemReferral()?.appealDeadlineDate"
                [originalValue]="originalReferral()?.appealDeadlineDate"
                [isDate]="true"
            />
        </div>
    </div>
</div>
